import { defineStore } from 'pinia'
import { readCookie } from '@outputinc/o-logins'
import { ref, computed } from 'vue'

const tokenCookieName = import.meta.env.VITE_OUTPUT_TOKEN_COOKIE_NAME
const refreshCookieName = import.meta.env.VITE_OUTPUT_REFRESH_COOKIE_NAME

export const useAuthStore = defineStore('AuthStore', () => {
  const token = ref(readCookie(tokenCookieName, false))
  const refresh = ref(readCookie(refreshCookieName, false))

  const updateTokens = (accessToken: string, refreshToken: string) => {
    token.value = accessToken
    refresh.value = refreshToken
  }

  const setTokens = () => {
    token.value = readCookie(tokenCookieName, false)
    refresh.value = readCookie(refreshCookieName, false)
  }

  const clearTokens = () => {
    token.value = ''
    refresh.value = ''
  }

  const isUserAuthenticated = computed(() => {
    return !!token.value
  })

  return {
    isUserAuthenticated,
    token,
    refresh,
    updateTokens,
    setTokens,
    clearTokens
  }
})
